// extracted by mini-css-extract-plugin
export default {"expense-allocation-table":"AllocationTable_expense-allocation-table__bNGmj","ant-table":"AllocationTable_ant-table__9ZuIy"};